import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/60_card_back_purple_crown/60_card_back_purple_crown"
 * Contains 1 texture(s)
 */
export class CardsBacks60CardBackPurpleCrownAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/60_card_back_purple_crown/60_card_back_purple_crown';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '60_purple_crown.png'
    ] as const;
}
